var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#A9CF3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3346 11.6641L17.668 14.9974L22.3346 18.3307V11.6641Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3346 10.3359H9.0013C8.26492 10.3359 7.66797 10.9329 7.66797 11.6693V18.3359C7.66797 19.0723 8.26492 19.6693 9.0013 19.6693H16.3346C17.071 19.6693 17.668 19.0723 17.668 18.3359V11.6693C17.668 10.9329 17.071 10.3359 16.3346 10.3359Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVideoCall);
export default __webpack_public_path__ + "static/media/ico_video_call.ea44075c67de471b2f094990ee5a8020.svg";
export { ForwardRef as ReactComponent };